var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import { bindActionCreators } from "redux";
import { Helmet } from "react-helmet";
import { createWithdraw as createWithdrawAction, cancelWithdraw as cancelWithdrawAction, withdrawData as withdrawDataAction, clearWithdrawError as clearWithdrawErrorAction } from "../../actions/withdraw/creators/withdraw";
import { getGambler as getGamblerAction } from "../../actions/profile/creators/profile";
import Bironex from "./Bironex";
import Uzcard from "./Uzcard";
import Active from "./Active";
import * as AccountResources from "../../constants/accountResourceNames";
var Withdraw = /** @class */ (function (_super) {
    __extends(Withdraw, _super);
    function Withdraw() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.componentDidMount = function () {
            _this.props.withdrawDataAction();
            _this.props.getGamblerAction();
        };
        _this.cancelWithdraw = function (e) {
            e.preventDefault();
            var withdrawal = _this.props.withdrawal;
            _this.props.cancelWithdrawAction(withdrawal.WithdrawalId);
        };
        return _this;
    }
    Withdraw.prototype.render = function () {
        var _a = this.props, user = _a.user, withdraw = _a.withdraw, languageId = _a.languageId, withdrawal = _a.withdrawal, cancelStatus = _a.cancelStatus;
        if (user === undefined) {
            return false;
        }
        if (withdrawal !== undefined &&
            Object.keys(withdrawal).length !== 0 &&
            withdrawal.constructor === Object &&
            cancelStatus !== 0) {
            return (_jsx(Active, { withdrawal: withdrawal, cancel: this.cancelWithdraw, cancelStatus: cancelStatus }));
        }
        var sharedProps = {
            user: user,
            languageId: languageId,
            withdraw: withdraw,
            fetching: this.props.fetching,
            rates: this.props.rates,
            createWithdrawAction: this.props.createWithdrawAction,
            clearWithdrawErrorAction: this.props.clearWithdrawErrorAction
        };
        var renderer = [];
        switch (user.accountResourceId) {
            case AccountResources.UZ:
                renderer.push(_jsx(Uzcard, __assign({}, sharedProps), languageId));
                break;
            case AccountResources.US:
                renderer.push(_jsx(Bironex, __assign({}, sharedProps), languageId));
                break;
            default:
                break;
        }
        return (_jsxs("div", __assign({ id: "content" }, { children: [_jsx(Helmet, { children: _jsxs("title", { children: [window.COMPANY_NAME, " \u2014 \u0421\u043D\u044F\u0442\u0438\u0435 \u0434\u0435\u043D\u0435\u0433"] }) }), _jsx("div", { children: renderer })] })));
    };
    return Withdraw;
}(React.Component));
Withdraw.propTypes = {
    user: PropTypes.object.isRequired,
    withdraw: PropTypes.object.isRequired,
    languageId: PropTypes.number.isRequired,
    rates: PropTypes.object.isRequired,
    fetching: PropTypes.bool.isRequired,
    withdrawal: PropTypes.any,
    cancelStatus: PropTypes.any,
    withdrawDataAction: PropTypes.func.isRequired,
    getGamblerAction: PropTypes.func.isRequired,
    createWithdrawAction: PropTypes.func.isRequired,
    cancelWithdrawAction: PropTypes.func.isRequired,
    clearWithdrawErrorAction: PropTypes.func.isRequired
};
var mapStateToProps = function (state) {
    var rates = {};
    var withdrawRates = state.withdraw.get("rates");
    if (withdrawRates && withdrawRates.length > 0) {
        rates = withdrawRates.find(function (r) { return r.SourceResourceId === 4; }) || {};
    }
    return {
        user: state.auth.user,
        languageId: state.application.get("languageId"),
        withdraw: state.withdraw,
        withdrawal: state.withdraw.get("withdrawal"),
        cancelStatus: state.withdraw.get("cancelStatus"),
        fetching: state.withdraw.get("fetching"),
        rates: rates
    };
};
var mapDispatchToProps = function (dispatch) {
    return bindActionCreators({
        withdrawDataAction: withdrawDataAction,
        getGamblerAction: getGamblerAction,
        createWithdrawAction: createWithdrawAction,
        cancelWithdrawAction: cancelWithdrawAction,
        clearWithdrawErrorAction: clearWithdrawErrorAction
    }, dispatch);
};
Withdraw = withRouter(connect(mapStateToProps, mapDispatchToProps)(Withdraw));
export default injectIntl(Withdraw);



// WEBPACK FOOTER //
// ./src/components/withdraw/Withdraw.jsx